import { FC } from 'react'
import { BrowserRouter, Switch, Route } from "react-router-dom";
import loadable, { LoadableClassComponent } from '@loadable/component'

import routes from '../../config/routes'
import guard from '../../helpers/guard'
import { IRoute } from 'types';
import Header from 'components/Header';
import { Box } from '@material-ui/core';

const Switcher: FC = (): JSX.Element => {
  return (
    <BrowserRouter>
      <Box position="relative">
        <Box style={{ background: 'linear-gradient(211.34deg, #00BFB3 17.35%, #0FD2CB 93.61%)' }} position="absolute" width="100%" zIndex="-5" height="300px" />
        <Switch>
          {routes.map((route: IRoute) => {
            const isAllowed: boolean = guard(route)
            const componentRoute: string = !isAllowed ? "NotAllowed" : route.component;
            const Component: LoadableClassComponent<any> = loadable(() => import(`pages/${componentRoute}`))

            return (
              <Route key={route.name} exact path={route.path}>
                {route.name !== 'Login SMS' &&
                  <Header />
                }
                <Component />
              </Route>
            );
          })}
        </Switch>
      </Box>
    </BrowserRouter>
  );
}

export default Switcher;
